namespace Matrix.Indexation {

	@Serenity.Decorators.registerClass()
	export class IndexationProfileSecuritiesPickerDialog extends Serenity.TemplatedDialog<any> {

		private pickerGrid: Data.SecurityPickerGrid;
		private indexCode: FormatLookupEditor;

		constructor() {
			super();

			this.pickerGrid = new Data.SecurityPickerGrid(this.byId("PickerGrid"));
			this.dialogTitle = "Select Securities";

			this.indexCode = new FormatLookupEditor($('<input type="hidden" placeholder="--index code--" />')
				.appendTo(this.pickerGrid["toolbar"].element), {
				lookupKey: IndexesRow.lookupKey
			});
		}

        public allowClear: boolean;

		protected getTemplate() {
			return `<div id="~_PickerGrid"></div>`;
		}

		protected getDialogOptions() {
			var opt = super.getDialogOptions();
			opt.buttons = [
				{
					text: Q.text("Dialogs.OkButton"),
					click: () => {
						if (!this.indexCode.value) {
							Q.notifyWarning("Please select an index code!");
							return;
                        }

						var selected = this.pickerGrid.selectedItems;
						if (!this.allowClear && !selected.length) {
							Q.notifyWarning("Please select securities");
							return;
						}

						if (!this.onSuccess || this.onSuccess(selected, this.indexCode.value))
							this.dialogClose();
					}
				},
				{
					text: Q.text("Dialogs.CancelButton"),
					click: () => {
						this.dialogClose();
					}
				}
			];
			return opt;
		}

		get selectedItems() {
			return this.pickerGrid.selectedItems;
		}

		get value() {
			return this.pickerGrid.value;
		}

		set value(value: string[]) {
			this.pickerGrid.value = value;
		}

        set criteria(value: any[]) {
            this.pickerGrid.criteria = value;
        }

		public onSuccess: (selected: Data.SecurityRow[], indexCode: string) => boolean;
	}
}